import gql from 'graphql-tag';
import { convertFilterRequestUrl } from '../../utils/utils';

export default ({ page, size, filter, sort }) => {
  const sortStr = sort ? `, sort: ${sort}` : '';
  const filterStr = filter
    ? `, filter: ${convertFilterRequestUrl(filter, ['commitmentTerm', 'serviceType', 'groupBy'])}`
    : '';
  const getCommitmentReport = `getCommitmentReport(page: ${page}, size: ${size}${sortStr}${filterStr})`;
  return gql`
    query {
      ${getCommitmentReport} {
        organization
        accountId
        clientId
        startDate
        endDate
        accumulatorId
        commitmentAmount
        accumulatorBalance
        serviceType
      }
    }
  `;
};
